$.fn.MobileImage = function() {
  let self = this
  self.has_moved = false
  self.images = []

  if (self.data('mobile-image')) {
    return self.data('mobile-image')
  }

  self.mobile_images = function() {
    self.has_moved = true
    self.images.each(function() {
      let desktop_image = $('<div class="desktop-image"></div>')
      $(this).data('desktop-image', desktop_image).before(desktop_image)
    })
    self.append(self.images)
  }

  self.desktop_images = function() {
    if (self.has_moved) {
      self.has_moved = false
      self.images.each(function() {
        $(this).data('desktop-image').replaceWith($(this))
      })
    }
  }

  return function() {
    self.closest('.row').find('.picture').each(function() {
      self.images.push($(this).get(0))
    })
    self.images = $(self.images)
    $.mlmi.mobile.add(self.mobile_images, self.desktop_images)
    self.data('mobile-image', self)
    return self
  }()
}
